import '../sass/scrolling-gallery.scss';

(() => {
    const $blocks = document.querySelectorAll('.block.scrolling-gallery');

    if (!$blocks.length) return;

    const pixelsPerSecond = 40;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setupTrack = ($viewport) => {
        const $track = $viewport.querySelector('.scrolling-gallery__track');
        const $group = $track?.querySelector('.scrolling-gallery__group');

        if (!$track || !$group || prefersReducedMotion) return;

        if (!$viewport._gallerySlides) {
            $viewport._gallerySlides = [...$group.children].map(($slide) => $slide.cloneNode(true));
        }

        const $slides = $viewport._gallerySlides;

        if (!$slides.length) return;

        $track.querySelectorAll('.scrolling-gallery__group').forEach(($existing, index) => {
            if (index > 0) $existing.remove();
        });

        $group.replaceChildren(...$slides.map(($slide) => $slide.cloneNode(true)));

        let guard = 0;
        while ($group.scrollWidth < $viewport.offsetWidth && guard < 12) {
            $slides.forEach(($slide) => $group.appendChild($slide.cloneNode(true)));
            guard += 1;
        }

        const $clone = $group.cloneNode(true);
        $clone.setAttribute('aria-hidden', 'true');
        $track.appendChild($clone);

        const duration = Math.max($group.scrollWidth / pixelsPerSecond, 8);
        $track.style.setProperty('--scrolling-gallery-duration', `${duration}s`);
        $track.classList.add('is-scrolling');
    };

    $blocks.forEach(($block) => {
        const $viewport = $block.querySelector('.scrolling-gallery__viewport');
        if (!$viewport) return;

        setupTrack($viewport);

        let resizeTimer;
        window.addEventListener('resize', () => {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(() => setupTrack($viewport), 150);
        });
    });
})();
